import { ChangeDetectionStrategy, ChangeDetectorRef, Component, inject } from '@angular/core';
import { RouterOutlet } from '@angular/router';

import { NotificationComponent } from '@app/shared/ui/notification/notification.component';
import { SpinnerComponent } from '@app/shared/ui/spinner/spinner.component';
import { SidebarComponent } from '@core/layout/sidebar/sidebar.component';

@Component({
  selector: 'app-root',
  imports: [RouterOutlet, SidebarComponent, NotificationComponent, SpinnerComponent],
  template: `
    <div class="notify-app">
      <app-sidebar [isOpen]="isSidebarOpen" (toggleSidebar)="sidebarHandler()" />
      <div class="notify-app__content" [class.sidebar-opened]="isSidebarOpen">
        <router-outlet />
      </div>
      <app-notification />
    </div>
    <app-spinner />
  `,
  styleUrl: './app.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AppComponent {
  public isSidebarOpen = false;

  private readonly _cdr: ChangeDetectorRef = inject(ChangeDetectorRef);

  public sidebarHandler(): void {
    this.isSidebarOpen = !this.isSidebarOpen;
    this._cdr.markForCheck();
  }
}
